import { absoluteTime, relativeTime } from '@/lib/format';

/**
 * Relative on the surface, exact on hover. Operators reading a crash timeline need
 * the precise instant; everyone else just wants "4 minutes ago".
 */
export function RelativeTime({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="text-ink-muted">—</span>;

  return (
    <time dateTime={value} title={absoluteTime(value)} className="text-ink-secondary">
      {relativeTime(value)}
    </time>
  );
}
